<template>
  <div id="firstSection">
    <div id="left" class="firstSectionParts">
      <div class="content">
        <h1>
          <span>MAKE <br />YOUR KIDS </span><br />SMARTER
        </h1>
      </div>
    </div>
    <div id="right" class="firstSectionParts">
      <div class="content">
        <img src="@/assets/img/kits/1.jpg" class="kitPic" />
        <h4>Maths Kits</h4>
        <p>
          A comprehensive range of maths kits created for use in the classroom.
          Designed for ease of use by teachers, these topic specific kits assist
          schools with easy resource management. A great range of resources in
          each kit
        </p>
        <button>Find More >></button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "firstSection"
};
</script>

<style lang="scss" scoped>
#firstSection {
  width: 100%;
  display: flex;
  margin: 30px 0 0;
  flex-direction: column;
  @include media-md {
    flex-direction: row;
  }
  @include media-md {
    margin: 50px 0 0;
  }
  @include media-xl {
    margin: 70px 0 0;
  }
  @include media-xxl {
    margin: 90px 0 0;
  }
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    @include media-md {
      display: unset;
    }

    margin: 0 auto;
    align-content: center;
  }
  .firstSectionParts {
    width: 100%;
    justify-content: center;
    h1 {
      //font-weight: 600;
      color: $color1;
      font-size: 2.5rem;
      @include media-md {
        font-size: 3.3rem;
      }
      @include media-lg {
        font-size: 4.1rem;
      }
      @include media-xl {
        font-size: 5rem;
      }
      span {
        color: $grey;
        font-weight: 400;
        letter-spacing: -0.09rem;
        text-align: center !important;
        @include media-md {
          letter-spacing: -0.1rem;
        }
        @include media-lg {
          letter-spacing: -0.3rem;
        }
      }
    }
    @include media-md {
      width: 50%;
      flex-grow: 1;
    }
  }
  #left {
    display: flex;
    align-items: left;
    flex-direction: column;
    text-align: center;
    @include media-md {
      text-align: left;
    }
  }
  #right {
    @include media-lg {
      padding: 0 25px 0 5px;
    }
    @include media-xl {
      padding: 0 45px 0 5px;
    }
    @include media-xxl {
      padding: 0 105px 0 5px;
    }
    .kitPic {
      width: 300px;
      height: auto;
    }
    h4 {
    }
    p {
      padding: 0;
    }
    button {
      color: $white;
      background-color: $color1;
      border: none;
      border-radius: 10px;
      padding: 4px 12px;
      font-size: 0.8rem;
      cursor: pointer;
    }
  }
}
</style>
